import dayjs from "dayjs";

dayjs.extend(require("dayjs/plugin/timezone"));
dayjs.extend(require("dayjs/plugin/utc"));

// adding zero to seconds
export const getSeconds = (time) => {
  try {
    let second = time.getSeconds().toLocaleString();
    return second.length > 1 ? second : "0" + second;
  } catch (error) {
    return "N/A";
  }
};

// adding zero to hours
export const getHours = (time) => {
  try {
    let hours = time.getHours().toLocaleString();
    return hours.length > 1 ? hours : "0" + hours;
  } catch (error) {
    return "N/A";
  }
};

// adding zero to minutes
export const getMinutes = (time) => {
  try {
    let minutes = time.getMinutes().toLocaleString();
    return minutes.length > 1 ? minutes : "0" + minutes;
  } catch (error) {
    return "N/A";
  }
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes < 10 ? "0" : ""}${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};


export function formatDate(dateString, langCode) {
  const date = new Date(dateString);
  const options = { day: "numeric", month: "long", year: "numeric" };
  return date.toLocaleDateString(
    langCode === "es" ? "es-MX" : "en-US",
    options,
  );
}

// Function to convert time format
export function formatTime1(timeString, langCode) {
  const date = new Date(timeString);
  const options = { hour: "numeric", minute: "2-digit", hour12: true };
  return date.toLocaleTimeString(
    langCode === "es" ? "es-MX" : "en-US",
    options,
  );
}

export function convertUTCToLocal2(utcDateString) {
  const utcDate = dayjs(utcDateString).format("YYYY-MM-DD HH:mm:ss").toString();
  //const offsetInMinutes = utcDate.getTimezoneOffset();
  const localDate = dayjs.utc(utcDate).local().toDate();
  return localDate.toLocaleString();
}